const brands = [
  { name: 'royal', id: 'rcl', domains: ['royal', 'rcl', 'localhost'], ldBrand: 'ROYAL' },
  { name: 'celebrity', id: 'cel', domains: ['cel', '0.0.0.0'], ldBrand: 'CELEBRITY' },
];
const getBrand = () => {
  // Handle test environment where window might not be defined
  if (typeof window === 'undefined') {
    return brands[0];
  }

  const host = window.location?.hostname || 'localhost';
  return brands.find((brand) => brand.domains.some((domain) => host.includes(domain))) || brands[0];
};

export default getBrand;
